import { ChevronLeftSharp, ChevronRightSharp } from '@mui/icons-material';
import { Container, Grid, ImageList, ImageListItem } from '@mui/material';
import MKBox from 'components/MKBox';
import MKPagination from 'components/MKPagination';
import MKTypography from 'components/MKTypography';
import data from 'csdd_data/csddGallery';

const GalleryCompo = () => {
  return (
    <Container>
      {data.length === 0 ? (
        <MKTypography textAlign='center' color='warning'>
          There are no photo galleries at the moment.
        </MKTypography>
      ) : (
        <>
          {data.map((gallery) => {
            return (
              <MKBox key={gallery.title}>
                <Grid container item xs={12} md={6}>
                  <MKTypography
                    textGradient
                    fontWeight='medium'
                    color='black'
                    variant='h4'
                    mb={5}
                  >
                    {gallery.title}
                  </MKTypography>
                </Grid>
                <MKBox
                  sx={{ width: '80%', height: '80%', overflowY: 'scroll' }}
                >
                  <ImageList variant='masonry' cols={3} gap={8}>
                    {gallery.images.map((item) => (
                      <ImageListItem key={item.img}>
                        <img
                          srcSet={item.img}
                          src={item.img}
                          alt={item.alt}
                          loading='lazy'
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </MKBox>
                <Container sx={{ mt: 10 }}>
                  <MKPagination placement='center'>
                    <MKPagination item>
                      <ChevronLeftSharp color='warning' />
                    </MKPagination>
                    <MKPagination item active>
                      1
                    </MKPagination>
                    <MKPagination item>2</MKPagination>
                    <MKPagination item>3</MKPagination>
                    <MKPagination item>
                      <ChevronRightSharp color='warning' />
                    </MKPagination>
                  </MKPagination>
                </Container>
              </MKBox>
            );
          })}
        </>
      )}
    </Container>
  );
};
export default GalleryCompo;
